module.exports = __webpack_public_path__ + "deactivated-badge.svg?7e659a271c67894d921d35032a728dbe";